export default {
  getSortedOrgItems: state=> {
      if (state.orgItems.length > 0)
          return state.orgItems.sort((a, b) => {
              var nameA = a.orgName.toLowerCase(), nameB = b.orgName.toLowerCase()
              if (nameA < nameB) //сортируем строки по возрастанию
                  return -1
              if (nameA > nameB)
                  return 1
              return 0
          })
      else
          return [];
  },


}
